/* eslint-disable */

export interface GetIrsInfoRequest {
  customer_token?: string;
}

export interface GetIrsInfoResponse {
  totp_enabled?: boolean;
  trust_device_factor_type?: GetIrsInfoResponseTrustDeviceFactorType;
}

export enum GetIrsInfoResponseTrustDeviceFactorType {
  SMS = "SMS",
  TOTP = "TOTP",
  UNKNOWN = "UNKNOWN",
}
